const {
  REACT_APP_TWITTER_URL,
  REACT_APP_FACEBOOK_URL,
  REACT_APP_INSTAGRAM_URL,
  REACT_APP_GITHUB_URL,
  REACT_APP_SLACK_URL,
  REACT_APP_ANDROID_URL,
  REACT_APP_IOS_URL
} = process.env;

export default {
  TWITTER_URL: REACT_APP_TWITTER_URL,
  FACEBOOK_URL: REACT_APP_FACEBOOK_URL,
  INSTAGRAM_URL: REACT_APP_INSTAGRAM_URL,
  GITHUB_URL: REACT_APP_GITHUB_URL,
  SLACK_URL: REACT_APP_SLACK_URL,
  ANDROID_URL: REACT_APP_ANDROID_URL,
  IOS_URL: REACT_APP_IOS_URL
};
